import { FC } from "react";
import { ReduxProvider } from "./ReduxProvider";

export const Providers: FC = ({ children }) => (
  <ReduxProvider>{children}</ReduxProvider>
);
